import React, { Component } from "react";
import Footer from "../../component/footer/Footer";
import Header from "../../component/header/Header";
import './Home.css';

class Home extends Component {
    render() {
        return (
            <div className="app">
                <Header />
                <Footer />
            </div>
        )
    }
}

export default Home;
